<template>
  <div class="addCollar main-content">
    <!-- 顶部菜单 -->
    <div class="topData">
      <base-form
        v-model="topData"
        :options="options"
        ref="topData"
        :rules="topDataRules"
        @input="handleChangeTopData"
        label-width="100px"
      ></base-form>
    </div>
    <!-- 数据表格 -->
    <div class="tableStyle">
      <vxe-grid
        border
        show-overflow
        resizable
        ref="collar"
        class="vxe-table-element"
        size="mini"
        align="left"
        :auto-resize="true"
        :data="baseData"
        :columns="columnList"
        :valid-config="{ message: 'none' }"
        :toolbar="{}"
        :edit-rules="rules"
        :edit-config="{ trigger: 'click', mode: 'row', activeMethod: activeRowMethod }"
        show-footer
        :footer-method="footerMethod"
        :footer-span-method="footerColspanMethod"
      >
        <template v-slot:buttons>
          <vxe-button
            @click="insertEvent(-1)"
            type="primary"
            icon="el-icon-plus"
            class="vxe-btn-primary"
            >{{ $t('xTable.insert') }}</vxe-button
          >
          <vxe-button
            @click="handleDelete('collar')"
            type="primary"
            icon="el-icon-delete"
            class="vxe-btn-delete"
            >{{ $t('xTable.delete') }}</vxe-button
          >
        </template>
      </vxe-grid>
      <footer class="fixed-bottom-btnList">
        <el-button class="fixed-bottom-btn" type="primary" @click="handleValid()">{{
          $t('functionBtn.save')
        }}</el-button>
      </footer>
    </div>
  </div>
</template>
<script>
  import baseForm from '@/components/form/base-form';
  import { mapState } from 'vuex';
  import { topDataRules } from './rules/rules';
  import { tableEditRules } from './rules/tableRules';
  import { dateFormat } from '@/filters';
  import API from '@/api/masterData/supplyChain';
  import collarAPI from '@/api/productCenter/collarDetails';
  // import DataBaseAPI from '@/api/dataBase';
  // import inputNumber from '@/components/form-item/input-number';
  // import ajaxSelect from '@/components/form-item/ajax-select';
  // import DictSelect from '@/components/DictSelect';
  // import SearchTable from '@/components/form-item/search-table';

  export default {
    name: 'collarAdd',
    components: { baseForm },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
        lang: (state) => state.lang.language,
      }),

      //顶部表单配置
      options() {
        // const data = this.topData;
        return [
          {
            type: 'select',
            label: this.$t('collarDetailsList.column.recipientsCompanyCode'),
            prop: 'recipientsCompanyCode',
            disabled: false,
            required: true,
            options: this.companyList,
          },
          {
            type: 'select',
            label: this.$t('collarDetailsList.column.recipientsDepartmentCode'),
            prop: 'recipientsDepartmentCode',
            options: this.departmentList,
            required: true,
          },
          {
            type: 'input',
            // type: "select",
            label: this.$t('collarDetailsList.column.createPersonNo'),
            prop: 'createPersonName',
            disabled: true,
            required: true,
            //options: this.requestByList
          },
          {
            type: 'input',
            label: this.$t('collarDetailsList.column.createDate'),
            prop: 'createDate',
            required: true,
            disabled: true,
          },
          {
            type: 'input',
            label: this.$t('collarDetailsList.column.storageCode'),
            prop: 'storageName',
          },
          {
            type: 'date',
            label: this.$t('collarDetailsList.column.outboundDate'),
            prop: 'outboundDate',
          },
          {
            type: 'input',
            label: this.$t('collarDetailsList.column.receiptNo'),
            prop: 'receiptNo',
          },
          {
            // 项目名称
            prop: 'projectCode',
            label: this.$t('collarDetailsList.column.projectName'),
            type: 'dict',
            required: true,
            dictType: 'produce_product_proname',
          },
          {
            // 领用明细账期
            prop: 'periodName',
            label: this.$t('collarDetailsList.column.periodName'),
            type: 'searchTable',
            searchType: 'pdPeriod',
            required: true,
            isMultiple: true,
            extraData: {
              projectCode: this.topData.projectCode,
              periodStatus: 'opened',
            },
            currentValue: this.topData.periodName,
          },
        ];
      },
      columnList() {
        return [
          { type: 'checkbox', width: 50 },
          {
            type: 'seq',
            // field: "sortNo",
            title: this.$t('collarDetailsList.column.sortNo'),
            width: 60,
          },
          /* {
          field: "goodsType",
          title: this.$t("collarDetailsList.column.goodsType"),
          editRender: { name: "ElSelect" },
          slots: {
            // 使用 JSX 渲染
            default: ({ row }) => {
              return [<span>{row.goodsTypeName}</span>];
            },
            edit: ({ row }) => {
              return [
                <dict-select
                  placeholder={this.$t(
                    "collarDetailsList.column.selectPlaceholder"
                  )}
                  type="productType"
                  value={row["goodsType"]}
                  onChange={(val, label) =>
                    this.handleChangeInput(val, label, row, "goodsType")
                  }
                ></dict-select>
              ];
            }
          }
        }, */

          //原料编码
          {
            field: 'productCode',
            title: this.$t('collarDetailsList.column.productCode'),
            width: 150,
            editRender: { name: 'ElInput', props: { clearable: true, disabled: true } },
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [<span>{row.productCode}</span>];
              },
              edit: ({ row }) => {
                return [
                  <search-table
                    searchType="produceProduct"
                    isMultiple={true}
                    currentValue={row['productCode']}
                    checkRowKeys={[row['productCode']]}
                    onInput={(val) => this.chooseTable(val, row)}
                    extraData={{
                      productStatus: '001', //生效
                      productClass: '0', //原料
                    }}
                  ></search-table>,
                ];
              },
            },
          },
          //原料名称
          {
            field: 'productName',
            title: this.$t('collarDetailsList.column.productName'),
            width: 140,
            editRender: { name: 'ElInput', props: { clearable: true, disabled: true } },
          },
          //规格型号
          {
            field: 'productSpec',
            title: this.$t('collarDetailsList.column.productSpec'),
            width: 140,
            editRender: { name: 'ElInput', props: { clearable: true, disabled: true } },
          },
          //主料/辅料
          {
            field: 'goodsTypeName',
            title: this.$t('collarDetailsList.column.productType'),
            width: 140,
            editRender: { name: 'ElInput', props: { clearable: true, disabled: true } },
          },
          //原料大类
          {
            field: 'productCategory',
            title: this.$t('collarDetailsList.column.productCategory'),
            width: 130,
            editRender: { name: 'ElInput', props: { clearable: true, disabled: true } },
          },

          /* //商品编码名称
        {
          field: "productName",
          title: this.$t("collarDetailsList.column.productName"),
          editRender: { name: "ElInput", props: { clearable: true } },
          slots: {
            // 使用 JSX 渲染
            default: ({ row }) => {
              return [
                <span>{ row.productName}</span>
              ]
            },
            edit: ({ row }) => {
              return [
                <search-table
                  searchType="produceProduct"
                  isMultiple={true}
                  currentValue={row['productName']}
                  checkRowKeys={[row['productCode']]}
                  onInput={val => this.chooseTable(val, row)}
                ></search-table>
              ]
            }
          }
        },
        //商品小类
        {
          field: "productCode",
          title: this.$t("collarDetailsList.column.productCode"),
          editRender: { name: "ElInput", props: { clearable: true,disabled:true } }
        }, */
          {
            field: 'partnerName',
            title: this.$t('collarDetailsList.column.partnerCode'),
            editRender: { name: 'ElInput' },
            width: 130,
          },
          {
            field: 'productCount',
            title: this.$t('collarDetailsList.column.productCount'),
            editRender: { name: 'ElInput', default: '' },
            width: 130,
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [<span>{row.productCount}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number
                    value={row['productCount']}
                    precision={this.$globalVar.qPoint}
                    max={99999999999.999999}
                    onInput={(val) => this.handleChangeNumber(val, row, 'productCount')}
                  ></input-number>,
                ];
              },
            },
          },
          {
            // 项目名称
            field: 'productUnit',
            title: this.$t('collarDetailsList.column.productUnit'),
            width: 130,
            editRender: {
              name: 'ElSelect',
              options: this.$baseRequest.getDictListMapByType('produce_basic_unit'),
              props: {
                clearable: true,
              },
              events: {},
            },
          },
          /* {
          field: "productUnit",
          title: this.$t("collarDetailsList.column.productUnit"),
          width: 130,
          editRender: {
            name: "ElSelect",
          },
          slots: {
            default: ({ row }) => {
              return [<span>{row.productUnit}</span>];
            },
            edit: ({ row }) => {
              return [
                <dict-select
                  placeholder={this.$t(
                    "collarDetailsList.column.selectPlaceholder"
                  )}
                  type="produce_basic_unit"
                  value={row["productUnit"]}
                  onChange={(val, label) =>
                    this.handleChangeInput(val, label, row, "productUnit")
                  }
                ></dict-select>
              ];
            }
          }
        }, */
          {
            field: 'detailLabel',
            title: this.$t('collarDetailsList.column.detailLabel'),
            width: 130,
            /* 自定义列为select组件样例 */
            editRender: {
              name: 'ElSelect',
              options: this.identification,
              props: { clearable: true },
            },
          },
          {
            field: 'remark',
            title: this.$t('collarDetailsList.column.remark'),
            width: 130,
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
        ];
      },
      rules() {
        return {
          goodsType: [
            {
              required: true,
              message: this.$t('collarDetailsList.placeholder.goodsType'),
            },
          ],
          productCode: [
            {
              required: true,
              message: this.$t('collarDetailsList.placeholder.productCode'),
            },
          ],
          productName: [
            {
              required: true,
              message: this.$t('collarDetailsList.placeholder.productName'),
            },
          ],
          productCount: [
            {
              required: true,
              message: this.$t('collarDetailsList.placeholder.productCount'),
            },
          ],
          productUnit: [
            {
              required: true,
              message: this.$t('collarDetailsList.placeholder.productUnit'),
            },
          ],
          taxRate: [
            {
              required: true,
            },
          ],
        };
      },
    },
    data() {
      return {
        topDataRules: topDataRules,
        tableEditRules: tableEditRules,
        topData: {
          companyCode: null, // 操作人所在公司代码
          companyName: null, //操作人所在公司名称
          departmentCode: null, // 操作人所在业务部门
          departmentName: null, //操作人所在部门名称
          recipientsCompanyCode: null, //公司代码
          recipientsCompanyName: null, //公司名称
          recipientsDepartmentCode: null, //业务部门代码
          recipientsDepartmentName: null, //部门名称

          // departmentCodes:"",//登录人所在部门编号
          createPersonNo: null, //操作人
          createPersonName: null, //操作人名称
          createDate: dateFormat(new Date()), // 申请时间
          storageName: null, // 出库仓库
          outboundDate: null, // 出库日期
          receiptNo: null, // 回单号
          projectCode: null, //项目名称编码
          projectName: null, //项目名称
          periodCode: null, //领用明细账期编码
          periodName: null, //领用明细账期
        },
        companyList: [], // 公司数据
        departmentList: [], // 部门数据
        requestByList: [], // 人员数据
        goodsTypeList: [], //商品类别数据
        partnerList: [], //合作伙伴
        baseData: [],
        goodsType: null,
        identification: [
          {
            label: this.$t('collarDetailsList.column.redBack'),
            value: this.$t('collarDetailsList.column.redBack'),
          },
        ],
        addRowObj: {
          goodsType: null,
          productCode: null,
          productName: null,
          partnerName: null,
          productCount: null,
          productUnit: null,
          detailLabel: null,
          remark: null,
        },
      };
    },
    mounted() {
      this.getDictList();
      if (this.$route.name.indexOf('Add') != -1) {
        // ['companyCode', 'companyName', 'departmentCode', 'departmentName'].map(item => {
        //   this.baseData[item] = this.userInfo[item];
        // });
        this.topData.createPersonName = this.userInfo.userName;
      } else {
        this.getData();
      }
    },
    methods: {
      //获取值
      chooseTable(val, row) {
        row.productName = val[0].productName;
        row.productCode = val[0].productCode;
        row.productSpec = val[0].productSpec;
        row.goodsTypeName = this.$baseRequest.getDictValueByType('productType', val[0].productType);
        row.goodsType = val[0].productType;
        row.productCategory = this.$baseRequest.getDictValueByType(
          'produce_product_category',
          val[0].productCategory
        );
      },
      activeRowMethod() {
        return true;
      },
      // 初始化数据
      getData() {},
      // 获取字典值
      getDictList() {
        // const tenantCode = this.userInfo.tenantCode;
        // 获取公司，部门数据
        this.$axios.post(API.GET_LIST_PERSON, { id: this.userInfo.userCode }).then((res) => {
          if (res.data.code === 0) {
            let companyList = res.data.data.personCompanyInfo;
            if (companyList.length > 0) {
              this.companyList = companyList.map((item) => {
                item['value'] = item.personCompanyCode;
                item['label'] = item.personCompanyName;
                return item;
              });
              this.topData.recipientsCompanyCode = this.companyList[0].value;
              this.topData.recipientsCompanyName = this.companyList[0].label;
            }
            let list = res.data.data.personDepartmentInfo;
            if (list.length > 0) {
              this.departmentList = list.map((item) => {
                item['value'] = item.personDepartmentCode;
                item['label'] = item.personDepartmentName;
                return item;
              });
              this.topData.recipientsDepartmentCode = this.departmentList[0].value;
              this.topData.recipientsDepartmentName = this.departmentList[0].label;
            }
          }
        });
        // 获取用户数据
        this.$axios.post(API.GET_LIST_PERSON, { personInfo: '' }).then((res) => {
          if (res.data.code === 0) {
            let list = res.data.data.personInfo;
            if (list.length > 0) {
              this.requestByList = list.map((item) => {
                item['value'] = item.id;
                item['label'] = item.personName;
                return item;
              });
            }
          }
        });
      },
      changeCompanyCode(val) {
        this.companyList.find((item) => {
          if (item.value === val) {
            this.topData.recipientsCompanyCode = item.value;
            this.topData.recipientsCompanyName = item.label;
          }
        });
      },
      changeDepartmentCode(val) {
        this.departmentList.find((item) => {
          if (item.value === val) {
            this.topData.recipientsDepartmentCode = item.value;
            this.topData.recipientsDepartmentName = item.label;
          }
        });
      },
      // 表单变化
      handleChangeTopData(value, prop) {
        if (prop == 'recipientsCompanyCode') {
          this.changeCompanyCode(value.recipientsCompanyCode);
        }
        if (prop == 'recipientsDepartmentCode') {
          this.changeDepartmentCode(value.recipientsDepartmentCode);
        }
        if (prop == 'projectCode') {
          this.topData.periodCode = this.topData.periodName = null;
          this.topData.projectCode = value.projectCode;
          this.topData.projectName = this.$baseRequest.getDictValueByType(
            'produce_product_proname',
            value.projectCode
          );
        }
        if (prop == 'periodName') {
          let res = value.periodName;
          if (res && res.length > 0) {
            this.topData.periodCode = res[0].periodCode;
            this.topData.periodName = res[0].periodName;
          } else {
            this.topData.periodCode = this.topData.periodName = null;
          }
        }
      },
      handleChangeNumber(val, row, type) {
        if (type == 'productCount') {
          row[type] = val;
        }
      },
      handleChangeInput(val, label, row, type) {
        if (type == 'goodsType') {
          row[type] = val;
          row.goodsTypeName = label;
          row.productCode = ' ';
          row.productName = ' ';
          row.goodsType = null;
          setTimeout(() => {
            row.goodsType = val;
          }, 10);
        }
        if (type == 'productCategory') {
          row[type] = val;
          row.goodsType = null;
          setTimeout(() => {
            row.goodsType = val;
          }, 10);
        }
        if (type == 'productCode') {
          row[type] = val.value;
          row.productName = val.label;
        }
        if (type == 'partnerCode') {
          row[type] = val.partnerCode;
          row.partnerName = val.partnerZhName;
        }
        if (type == 'productUnit') {
          row[type] = val;
          row.productUnit = null;
          setTimeout(() => {
            row.productUnit = val;
          }, 10);
        }
      },
      // 删除
      handleDelete(tableTpye) {
        const selectedList = this.$refs[tableTpye].getSelectRecords(); // 或许选中数据
        if (selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('collarDetailsList.message.noData'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction()
          .then(() => {
            this.$refs[tableTpye].removeSelecteds();
            this.baseData[tableTpye] = this.$refs[tableTpye].getTableData().fullData;
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('collarDetailsList.message.deleteSuccess'),
            });
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('collarDetailsList.message.cancelled'),
            });
          });
      },
      handleValid() {
        // 顶部表单校验
        this.$refs.topData.$refs.ruleForm.validate((valid) => {
          if (valid) {
            // 表格内容校验
            this.handleSave();
          } else {
            this.$message({
              showClose: true,
              message: this.$t('collarDetailsList.message.baseDataIncomplete'),
              type: 'warning',
            });
          }
        });
      },
      // 载具表格新增一行
      insertEvent(row) {
        this.$refs.collar.validate().then(() => {
          let record = JSON.parse(JSON.stringify(this.addRowObj));
          this.$refs.collar.insertAt(record, row).then(({ row }) => {
            this.$refs.collar.setActiveRow(row);
          });
        });
      },
      // 返回表单数据
      exportBaseData() {
        let sign = false;
        this.$refs.topData.$refs.ruleForm.validate((valid) => {
          if (valid) {
            sign = true;
          } else {
            sign = false;
          }
        });
        return sign ? this.baseData : false;
      },
      // 返回表格数据
      exportTableData() {
        const tableData = this.$refs.collar.getTableData().fullData;
        return new Promise((resolve) => {
          this.$refs.collar.validate().then(() => {
            resolve(tableData);
          });
        });
      },
      async handleSave() {
        /* let baseData = this.exportBaseData();
      let details = await this.exportTableData();
      if (baseData && details) {
      baseData = this.$baseRequest.assignObj(baseData);
      let insertList = [];
      for (let item of this.details) {
        insertList.push(Object.assign(item, baseData));
      }

        this.loading.startLoading();
        let res = await this.$axios.post(collarAPI.COLLARDETAILS_SAVE_API, insertList);
        if (res) {
          this.loading.endLoading();
          if (res.data.code == 0) {
            this.$message({
              showClose: true,
              message:  this.$t("message.saveSussess"),
              type: "success",
            });
            this.$baseRequest.linkBackRouteUrl(
              "/production/collarDetailsAdd",
              "collarDetailsAdd",
              "",
              "/production/collarDetailsList",
              "collarDetailsList",
              ""
            );
          } else {
            this.$message({
              showClose: true,
              message: this.$t("alert.error"),
              type: "error",
            });
          }
        }
      } */

        let details = await this.exportTableData();
        if (details) {
          this.loading.startLoading();
          // let params = Object.assign(this.topData);
          this.baseData = this.$refs.collar.getTableData().fullData;
          let insertList = [];
          for (let item of this.baseData) {
            delete item.goodsTypeName;
            insertList.push(Object.assign(item, this.$baseRequest.assignObj(this.topData)));
          }
          this.$axios.post(collarAPI.COLLARDETAILS_SAVE_API, insertList).then((res) => {
            this.loading.endLoading();
            if (res.data.code === 0) {
              this.$message({
                showClose: true,
                message: this.$t('collarDetailsList.message.saveSuccess'),
                type: 'success',
              });

              this.returnPath();
            }
          });
        }
      },
      returnPath() {
        // 返回列表页
        let path = {
          fromPath: {
            path: '/production/collarAdd',
            name: 'collarAdd',
            meta: {
              keepAlive: true,
            },
          },
          toPath: {
            path: '/production/collarDetailsList',
            name: 'collarDetailsList',
            meta: {
              keepAlive: false,
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      footerMethod({ columns, data }) {
        return [
          //小计
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return this.$t('collarDetailsList.column.subTotal');
            }

            if (['productCount'].includes(column.property)) {
              return data
                .map((i) => i['productCount'])
                .reduce((acc, cur) => {
                  const num = this.$cal.calCommon(acc, cur, '+');
                  return num;
                }, 0);
            }

            return null;
          }),
        ];
      },
      footerColspanMethod({ columnIndex }) {
        console.log(columnIndex);
      },
    },
  };
</script>
<style>
  .addCollar .isShowLabel .el-form-item__content {
    margin-left: 0 !important;
  }
  .addCollar .textOver label {
    line-height: unset;
  }
  .addCollar .dateInput .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: unset !important;
  }
</style>
<style scoped>
  .addCollar {
    padding-bottom: 100px;
  }
  .addCollar .el-select,
  .el-input {
    width: 100%;
  }
</style>
